import { css } from 'twin.macro';

import React, { Fragment, useEffect, useRef, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Card, Form, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import ID from '../../../_helpers/uuid';

import TeamSelectFilter from '../TeamSelectFilter';
import ChanelSelectFilter from '../ChannelSelectFilter';
import { BiArrowBack } from 'react-icons/bi';
import { FaRegSave } from 'react-icons/fa';
import { RiDraftLine } from 'react-icons/ri';

//icons
import { MdDelete } from 'react-icons/md';

import { delay, fetchWrapper } from '../../../_helpers';

import FormElement from './FormElement';
import { AiFillCopy } from 'react-icons/ai';
import { customCheckbox } from '../../../_elements/CustomCheckbox';
import SmartPdf from './smartpdf';
import { addFormField, deleteFormField, handleDeleteFormObj, reorderFormField } from '@/_redux/actions/ActionForm';
import { FloatingContainer } from './smartpdf/styles';
import { ExpandableDiv } from '@/_elements/Button';
import { showConfirmationAlert, showLoadingAlert, showSuccessAlert } from './FormBuilder/alerts';
import { BootstrapToolTip } from '@/_elements/ToolTip';
import { BsTrash, BsGripVertical } from 'react-icons/bs';
import { ActionStyles } from '../reusableStyles';
import { VscLoading } from 'react-icons/vsc';
import FormPickerModal from './FormPickerModal';
import { buildElementOptions } from './FormPicker';
import { LoadingSpinner } from '@/_elements/Loaders';
import FormSettings from './FormBuilder/FormSettings';
import FormElementOrder from './FormBuilder/FormElementOrder';
import FormElementControl from './FormBuilder/FormElementControl';
import FormLockModal from './FormLock/FormLockModal';

const DynamicPreview = ({
    addFormField,
    deleteFormField,
    reorderFormField,
    placeholderName = null,
    formName = null,
    selectedRooms = null,
    selectedTeams = null,
    editformId = null,
    formformType = 'normal',
    specialityForm,
    formLocationRequired = true,
    formElements,
    teamId = null,
    channelId = null,
    teams,
    formVisibleTo,
    currUser,
    pdfTemplateData,
    isDraftForm,
}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [selectedTeamOptions, setSelectedTeamOptions] = useState(selectedTeams);
    const [selectedRoomOptions, setSelectedRoomOptions] = useState(selectedRooms);
    const [name, setName] = useState('');
    const [formType, setFormType] = useState(formformType);
    const [specialityFormType, setSpecialityFormType] = useState(specialityForm?.type);
    const [isLocationRequired, setIsLocationRequired] = useState(formLocationRequired);
    const [pdfTemplate, setPdfTemplate] = useState({ ...(pdfTemplateData || {}) });
    const [error, setError] = useState({});
    const [loading, setLoading] = useState(false);
    const [visibleTo, setVisibleTo] = useState(formVisibleTo || ['supervisor', 'doctor', 'family', 'user']);
    const [showFormPickerModal, setShowFormPickerModal] = useState(false);
    const hasComponentMounted = useRef(false);
    const formElementRefs = useRef({});
    function handleVisibleToChange(event) {
        const role = event.target.value;
        setVisibleTo((prev) => {
            const newRoles = prev.includes(role) ? prev.filter((x) => x !== role) : [...visibleTo, role];
            if (
                ['user', 'family', 'doctor'].some((basicRole) => newRoles.includes(basicRole)) &&
                !newRoles.includes('supervisor')
            ) {
                newRoles.push('supervisor');
            }
            return newRoles;
        });
    }

    const options = [
        { value: 'normal', label: 'Normal' },
        { value: 'sos', label: 'Start Of Service' },
        { value: 'eos', label: 'End Of Service' },
        { value: 'multipleSubmission', label: 'Multiple Submissions' },
        { value: 'speciality', label: 'Speciality Form' },
    ];

    const specialityFormOptions = [
        { value: 'evvClientSetupForm', label: 'EVV Client Setup Form' },
        { value: 'evvStaffSetupForm', label: 'EVV Staff Setup Form' },
        { value: 'evvVisitBackupForm', label: 'EVV Visit Backup Form' },
        { value: 'userCertificate', label: 'Certificate Form' },
        { value: 'zealEmployee', label: 'Zeal Employee Onboarding Form' },
        { value: 'timeOff', label: 'Time Off Form' },
        { value: 'payrollReceiptForm', label: 'Receipt Form (Expense)' },
        { value: 'clientMedications', label: 'Medications Form' },
        { value: 'jobPost', label: 'Job Post' },
        { value: 'jobPostRaw', label: 'Job Post (Raw Text Prep)' },
    ];

    useEffect(() => {
        setName(formName);
        setFormType(formformType);
        setIsLocationRequired(formLocationRequired);
        teamId &&
            setSelectedTeamOptions([
                { value: teamId, label: teams.find((team) => teamId === (team.id || team._id))?.name },
            ]);
    }, [teamId, formName, formformType, formLocationRequired]);

    const onEdit = (form) => {
        addFormField(form, { formId: editformId });
    };

    const handleItem = (data) => {
        dispatch({ type: 'REORDER_FORM', payload: data });
    };

    const handleDelete = (formElementId) => {
        deleteFormField(formElementId, { formId: editformId });
    };

    const set_Evv_Default = () => {
        dispatch({ type: 'SET_EVV_DEFAULT' });
    };

    const set_Speciality_Form = (type) => {
        if (type) {
            dispatch({ type });
        }
    };
    const handleDeleteForm = () => {
        dispatch({ type: 'REMOVE_fORM' });
        if (teamId || channelId) {
            history.push(`/form`);
        } else {
            history.push('/master-form-library');
        }
    };

    const onDragEnd = (result) => {
        const { source, destination, draggableId } = result;

        if (!destination) {
            return;
        }
        if (source.droppableId === 'formPicker') {
            const elementOptions = buildElementOptions({ key: draggableId });
            addFormField(elementOptions, {
                formId: editformId,
                formElementIndex: destination.index,
            });
            return setShowFormPickerModal(false);
        } else {
            const movedField = formElements.find((item) => item.id === draggableId);
            if (movedField) {
                reorderFormField(movedField, {
                    formId: editformId,
                    formElementIndex: destination.index,
                });
            }

            const tempItems = reorder(formElements, result.source.index, result.destination.index);
            handleItem(tempItems);
        }
    };

    // a little function to help us with reordering the result
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const grid = 8;
    const getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: 'none',
        padding: grid * 2,
        margin: `0 0 ${grid}px 0`,

        // change background colour if dragging
        background: isDragging ? 'lightgreen' : 'white',

        // styles we need to apply on draggables
        ...draggableStyle,
    });

    const getListStyle = (isDraggingOver) => ({
        background: isDraggingOver ? 'lightblue' : 'white',
        padding: formElements.length ? grid : 0,
    });

    const handlePatchForm = async () => {
        try {
            if (!editformId) {
                return;
            }
            const tempData = {
                name: (name || '').trim() || formName,
                type: formType?.value || formType,
                specialityForm: {
                    ...(formType === 'speciality' ? { type: specialityFormType } : {}),
                },
                isLocationOptional: !isLocationRequired,
                visibleTo,
                pdfTemplate,
            };
            const body = { ...tempData };
            await fetchWrapper.patch(`forms/${editformId}`, body);
        } catch (err) {
            toast.error(err?.message || 'Something went wrong while patching form');
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (!hasComponentMounted.current) {
            hasComponentMounted.current = true;
            return;
        }

        const timeout = setTimeout(() => {
            handlePatchForm();
        }, 3000);

        return () => clearTimeout(timeout);
    }, [name, visibleTo, formType, specialityFormType, isLocationRequired, pdfTemplate]);

    const handleFormSave = async (options) => {
        try {
            setLoading(true);

            const formData = {
                name,
                type: formType?.value || formType,
                specialityForm: {
                    ...(formType === 'speciality' ? { type: specialityFormType } : {}),
                },
                data: formElements.reduce((acc, current) => {
                    if (current.fieldName) {
                        return acc.concat(current);
                    } else {
                        let tempCurrent = { ...current };
                        delete tempCurrent.fieldName;
                        return acc.concat(tempCurrent);
                    }
                }, []),
                isLocationOptional: !isLocationRequired,
                visibleTo,
                pdfTemplate,
                ...(options?.draft ? { draft: true } : {}),
            };

            if (!name) {
                const message = 'Form Name is required';
                toast.error(message);
                return setError({ name: message, room: '' });
            }
            if (!selectedRoomOptions?.length && !channelId) {
                const message = 'Chat Room is required';
                toast.error(message);
                return setError({ room: message });
            }
            if (formData?.type === 'speciality' && !specialityFormType) {
                const message = 'Speciality Form Type is required';
                toast.error(message);
                return setError({ specialityFormType: message });
            }

            const isServiceOptionsEmpty = formData.data.some(
                (element) => element.key === 'ServiceRadio' && element.data.length === 0
            );

            if (isServiceOptionsEmpty) {
                return toast.error('Services Options must not be empty! Please add Service options.');
            }

            formElements.forEach((element) => {
                if (['pdf', 'photo'].includes(element?.type) && !element?.data) {
                    throw new Error(`Please upload file in ${element.type}`);
                }
            });

            // no teamId then its admin view
            if (!teamId) {
                if (!selectedRoomOptions.length) {
                    return setError({ name: '', room: 'Chat room is required' });
                }
                formData.chatroom = selectedRoomOptions.map((opt) => opt.value);
            } else {
                if (channelId) {
                    formData.chatroom = [channelId];
                } else if (selectedRoomOptions.length) {
                    formData.chatroom = selectedRoomOptions.map((opt) => opt.value);
                }
                formData.team = [teamId];
            }
            let response;
            if (editformId) {
                response = await fetchWrapper.put(`forms/${editformId}`, formData);
                toast.success('Form Edited Successfully');
            } else {
                await fetchWrapper.post('forms', formData);
                toast.success('Form Added');
            }

            setError({});
            dispatch({ type: 'REMOVE_fORM' });
            if (options.draft && response?.data) {
                showLoadingAlert('Please wait...', {
                    allowOutsideClick: false,
                });
                await delay(2000);

                for (let idx in response.data) {
                    if (idx % 50 === 0) {
                        await delay(50);
                    }
                    let newFormData = Object.assign({}, response.data[idx]);
                    newFormData.id = response.data[idx]._id;
                    dispatch({ type: 'ADD_FORM_DATA', payload: newFormData });
                }
                return;
            }
            if (channelId) {
                history.push(`/form/`);
            } else if (teamId) {
                history.push(`/form/`);
            } else {
                history.push('/master-form-library');
            }
        } catch (err) {
            toast.error(err.message);
        } finally {
            setLoading(false);
            showSuccessAlert();
        }
    };

    const handleDeleteDraftForm = async (propformId) => {
        try {
            setLoading(true);
            const formId = editformId || propformId;
            const confirm = await showConfirmationAlert('Are you sure you want to delete this form?');
            if (!confirm.isConfirmed) return;
            const deleted = await handleDeleteFormObj(formId);

            if (deleted) {
                if (!channelId && !teamId) {
                    history.push('/master-form-library');
                } else {
                    history.push('/form/');
                }
            } else {
                toast.error('Failed to delete the form');
            }
        } catch (err) {
            toast.error(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleServiceFormChange = (selectedOption) => {
        if (formType === 'normal' || formType.value === 'normal') {
            if (
                selectedOption.value !== 'normal' &&
                selectedOption.value !== 'multipleSubmission' &&
                selectedOption.value !== 'speciality'
            ) {
                set_Evv_Default();
            }
        }
        if (formType !== 'speciality') {
            setSpecialityFormType({});
        }
        setFormType(selectedOption.value);
    };

    const handleLocationChange = () => {
        setIsLocationRequired(!isLocationRequired);
    };

    const handleCopy = (form) => {
        var elementOptions = {
            id: ID.uuid(),
            key: form.key,
            fieldName: form.fieldName,
            type: form.type,
            options: form.options,
        };
        if (form.instruction) {
            elementOptions['instruction'] = form.instruction;
        }
        const optionFieldKeys = ['Checkbox', 'Radio', 'Select'];
        if (form?.data && Array.isArray(form.data)) {
            let copyFormData = form.data.map((data) => Object.assign({}, data));
            let uniquiedValuesFormData = copyFormData.map((data) => {
                if ((data?.config || {})?.parentFormElement) {
                    data.config = undefined;
                }
                if (optionFieldKeys.includes(form.key)) {
                    return {
                        ...data,
                        value: ID.uuid(),
                    };
                }
                return { ...data };
            });
            elementOptions['data'] = uniquiedValuesFormData;
        }
        addFormField(elementOptions, { formId: editformId, from: 'DynamicPreview' });
    };

    const [editingOrderIndex, setEditingOrderIndex] = useState(null);

    const handleInputReorder = (currentIndex, newIndex) => {
        const reorderedItems = reorder(formElements, currentIndex, newIndex);
        handleItem(reorderedItems);

        const movedField = reorderedItems[newIndex];
        reorderFormField(movedField, {
            formId: editformId,
            formElementIndex: newIndex,
        });

        setEditingOrderIndex(null);

        setTimeout(() => {
            const movedRef = formElementRefs.current[movedField.id];
            if (movedRef?.current) {
                movedRef.current.focus();
                movedRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                movedRef.current.style.borderRadius = '15px';
                movedRef.current.style.boxShadow = '0 0px 10px 4px #50aeb0';
                movedRef.current.style.transition = 'box-shadow 0.5s ease-in-out';

                setTimeout(() => {
                    if (formElementRefs.current[movedField.id]?.current) {
                        formElementRefs.current[movedField.id].current.style.boxShadow = 'none';
                    }
                }, 5000);
            }
        }, 200);
    };

    return (
        <div className="w-100 custom-card">
            <Form className=" mb-4 mt-2 text-dark-grey">
                <Form.Row>
                    <Form.Label>Form Name</Form.Label>
                    <Form.Control
                        type="text"
                        value={name || ''}
                        onChange={(e) => setName(e.target.value)}
                        placeholder={placeholderName}
                    />
                    <Form.Text className="text-danger">{error.name}</Form.Text>
                </Form.Row>
                <div
                    className="d-flex"
                    css={css`
                        gap: 12px;
                        padding: 12px 0;
                    `}
                >
                    <div className="d-flex flex-column w-100">
                        <Form.Label>Form Type</Form.Label>
                        <Select
                            classNamePrefix="select"
                            isSearchable
                            name="serviceform"
                            options={options}
                            defaultValue={options.filter((option) => option.value === formType)[0]}
                            onChange={handleServiceFormChange}
                        />
                    </div>
                    <div className="d-flex flex-column w-100">
                        <Form.Label>Visible To </Form.Label>
                        <div
                            className="h-auto overflow-hidden d-flex"
                            css={css`
                                border: 1px solid #ccc;
                                border-radius: 4px;
                                padding: 4px 6px;
                            `}
                        >
                            {['user', 'doctor', 'family', 'supervisor'].map((role) => (
                                <div key={role}>
                                    <input
                                        id={`chatInput_${role}`}
                                        type="checkbox"
                                        css={customCheckbox}
                                        onChange={handleVisibleToChange}
                                        value={role}
                                        checked={visibleTo?.includes(role)}
                                        disabled={
                                            role === 'supervisor' &&
                                            ['user', 'doctor', 'family'].some((basicRole) =>
                                                visibleTo.includes(basicRole)
                                            )
                                        }
                                    />
                                    <label
                                        htmlFor={`chatInput_${role}`}
                                        className="mr-4"
                                        css={css`
                                            text-transform: capitalize;
                                        `}
                                    >
                                        {{ doctor: 'Third Party' }[role] ?? role}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {/* Speciality Form */}
                {formType === 'speciality' && (
                    <div
                        className="d-flex"
                        css={css`
                            gap: 12px;
                            padding: 12px 0;
                        `}
                    >
                        <div className="d-flex flex-column w-100">
                            <Form.Label>Speciality Form Type</Form.Label>
                            <Select
                                classNamePrefix="select"
                                isSearchable
                                name="specialityFormType"
                                options={specialityFormOptions}
                                defaultValue={
                                    specialityFormOptions.filter((option) => option.value === specialityFormType)[0]
                                }
                                onChange={(option) => {
                                    setSpecialityFormType(option.value);
                                    const specialityFormMap = {
                                        timeOff: 'SET_PTO_DEFAULT',
                                        zealEmployee: 'SET_ZEAL_EMPLOYEE_DEFAULT',
                                        userCertificate: 'SET_USER_CERTIFICATE_DEFAULT',
                                        evvVisitBackupForm: 'SET_EVV_VISIT_BACKUP_FORM_DEFAULT',
                                        evvStaffSetupForm: 'SET_EVV_STAFF_SETUP_DEFAULT',
                                        evvClientSetupForm: 'SET_EVV_CLIENT_SETUP_DEFAULT',
                                        payrollReceiptForm: 'SET_PAYROLL_RECEIPT_DEFAULT',
                                        clientMedications: 'SET_CLIENT_MEDICATIONS_DEFAULT',
                                        jobPost: 'SET_JOB_POST_DEFAULT',
                                        jobPostRaw: 'SET_JOB_POST_RAW_DEFAULT',
                                    };

                                    const selectedForm = specialityFormMap[option.value];
                                    if (selectedForm) {
                                        set_Speciality_Form(selectedForm);
                                    } else {
                                        console.log('Invalid Speciality Form Type', option?.value);
                                    }
                                }}
                            />
                            <Form.Text className="text-danger">{error.specialityFormType}</Form.Text>
                        </div>
                    </div>
                )}
                {teamId ? null : (
                    <Form.Row>
                        <div className="w-100">
                            <Form.Label>Teams</Form.Label>
                            <TeamSelectFilter
                                isMulti
                                disabled={!!teamId}
                                selectedTeamOption={selectedTeamOptions}
                                setSelectedTeamOption={setSelectedTeamOptions}
                            />
                        </div>
                    </Form.Row>
                )}
                <Form.Row>
                    <div className="w-100">
                        <Form.Label>Chatrooms</Form.Label>
                        <ChanelSelectFilter
                            isMulti
                            teamIds={selectedTeamOptions?.map((option) => option?.value)}
                            disabled={!!channelId}
                            assignedChannel={channelId}
                            selectedOption={selectedRoomOptions}
                            onRoomSelect={setSelectedRoomOptions}
                        />
                        <Form.Text className="text-danger">{error.room}</Form.Text>
                    </div>
                </Form.Row>
                <div
                    className="d-flex"
                    css={css`
                        gap: 12px;
                        padding: 12px 0 0;
                        justify-content: flex-end;
                    `}
                >
                    <input
                        id="is_location_required"
                        type="checkbox"
                        css={customCheckbox}
                        onChange={handleLocationChange}
                        value={isLocationRequired}
                        checked={isLocationRequired}
                    />
                    <label
                        htmlFor="is_location_required"
                        className="mr-4"
                        css={css`
                            text-transform: capitalize;
                        `}
                    >
                        Location Required
                    </label>
                </div>
            </Form>
            <Form.Row>
                <div className="w-100 d-flex justify-content-end">
                    <div style={{ position: 'relative' }}>
                        <SmartPdf
                            key={editformId}
                            onUploadPdfTemplate={(value) => {
                                setPdfTemplate((prev) => ({ ...prev, ...(value || {}) }));
                            }}
                            url={pdfTemplate?.url}
                        />
                    </div>
                </div>
            </Form.Row>
            <hr />
            <Card
                className="border-primary"
                css={css`
                    min-height: 150px;
                    height: fit-content;
                    width: ${showFormPickerModal ? '75%' : '100%'};
                    transition: width 0.3s ease;
                `}
            >
                <DragDropContext onDragEnd={onDragEnd}>
                    <FormPickerModal
                        formId={editformId}
                        openFormBuilder
                        show={showFormPickerModal}
                        setShowFormPickerModal={setShowFormPickerModal}
                        draggable={true}
                    />
                    <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                            >
                                {formElements.length > 0 &&
                                    formElements.map((form, index) => {
                                        if (!formElementRefs.current[form.id]) {
                                            formElementRefs.current[form.id] = React.createRef();
                                        }
                                        return (
                                            <Draggable key={form.id} draggableId={form.id} index={index}>
                                                {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style
                                                        )}
                                                    >
                                                        <div
                                                            key={form.id}
                                                            ref={formElementRefs?.current[form.id]}
                                                            className={`form-element `}
                                                            css={css`
                                                                margin-bottom: 5px;
                                                                padding: 1rem 0.5rem 1rem 1rem;
                                                                display: flex;
                                                                flex-direction: row;
                                                                justify-content: flex-start;
                                                                align-items: center;
                                                            `}
                                                        >
                                                            <FormElementOrder
                                                                index={index}
                                                                editingOrderIndex={editingOrderIndex}
                                                                formElements={formElements}
                                                                setEditingOrderIndex={setEditingOrderIndex}
                                                                handleInputReorder={handleInputReorder}
                                                            />
                                                            <div
                                                                className="d-flex justify-content-between"
                                                                css={css`
                                                                    flex: 1;
                                                                    align-items: center;
                                                                `}
                                                            >
                                                                <FormElement
                                                                    form={form}
                                                                    isPreview
                                                                    className="text-dark-grey h5"
                                                                />
                                                                <FormElementControl
                                                                    form={form}
                                                                    onEdit={onEdit}
                                                                    handleCopy={handleCopy}
                                                                    handleDelete={handleDelete}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        );
                                    })}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
                {formElements.length === 0 && <div className="d-flex m-auto">Add Elements</div>}
                {loading && <LoadingSpinner size={124} />}
            </Card>

            <FloatingContainer bottom="25px" left="120px" zIndex={2}>
                <ExpandableDiv
                    width="fit-content"
                    backgroundColor="#fff"
                    borderColor="#ccc"
                    textColor="#50aeb0"
                    height="60px"
                >
                    <ActionStyles>
                        <BootstrapToolTip text={'Form Elements count'} side={'top'}>
                            <span className="mr-2" style={{ color: '#000' }}>
                                {' '}
                                #{formElements.length}
                            </span>
                        </BootstrapToolTip>

                        {loading ? (
                            <div style={{ width: '150px' }}>
                                <VscLoading className="spin mr-2" />
                                Please wait...
                            </div>
                        ) : (
                            <div className="w-100 d-flex justify-content-between align-items-center">
                                <BootstrapToolTip text={'Go Back'} side={'top'}>
                                    <BiArrowBack
                                        className={`icon archiveIn`}
                                        onClick={handleDeleteForm}
                                        disabled={loading}
                                    />
                                </BootstrapToolTip>
                                <FormSettings formId={editformId} />
                                <span style={{ color: 'gray' }}>-</span>
                                <FormLockModal formId={editformId} />
                                {isDraftForm && (
                                    <Fragment>
                                        <BootstrapToolTip text={'Delete Form'} side={'top'}>
                                            <BsTrash
                                                className={`icon delete`}
                                                onClick={() => handleDeleteDraftForm()}
                                                disabled={loading}
                                            />
                                        </BootstrapToolTip>
                                    </Fragment>
                                )}
                                {formElements.length > 0 ? (
                                    <Fragment>
                                        <BootstrapToolTip text={'Save Form'} side={'top'}>
                                            <FaRegSave
                                                className={`icon archive`}
                                                onClick={handleFormSave}
                                                disabled={loading}
                                            />
                                        </BootstrapToolTip>
                                    </Fragment>
                                ) : null}
                                <BootstrapToolTip text={'Save as Draft'} side={'top'}>
                                    <RiDraftLine
                                        className={`icon edit`}
                                        onClick={() => handleFormSave({ draft: true })}
                                        disabled={loading}
                                    />
                                </BootstrapToolTip>
                            </div>
                        )}
                    </ActionStyles>
                </ExpandableDiv>
            </FloatingContainer>
        </div>
    );
};

const mapStateToProps = (state) => ({
    formElements: state.formData.formElements,
    teams: state.teams.teams,
    teamRooms: state.rooms.teamRooms,
    currUser: state.user.user,
});

const mapDispatchToProps = {
    addFormField,
    deleteFormField,
    reorderFormField,
};

export default connect(mapStateToProps, mapDispatchToProps)(DynamicPreview);
